module.exports = __webpack_public_path__ + "images/d-ofitserova-7260b3.jpg";